var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedotsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.294,
    height: 23.903,
    viewBox: "0 0 7.294 23.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.647,16.482A3.474,3.474,0,1,1,24,19.952,3.56,3.56,0,0,1,27.647,16.482ZM24,11.47a3.652,3.652,0,0,0,7.294,0,3.652,3.652,0,0,0-7.294,0Zm0,16.963a3.652,3.652,0,1,0,3.647-3.47A3.56,3.56,0,0,0,24,28.433Z",
    transform: "translate(-24 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotsicon);
export default __webpack_public_path__ + "static/media/threedotsicon.ef4fbc772b37e000cfb33f775d8c59da.svg";
export { ForwardRef as ReactComponent };